<template>
    <Layout>
        <div class="bg-[#00395A0D] py-12 md:py-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12 md:mb-16">
                    <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Our Past Vice Presidents</h1>
                    <p class="mt-4 text-lg sm:text-xl text-black max-w-3xl mx-auto">
                        Recognizing the valuable contributions of past Vice Presidents of Shri Ghoghari Lohana Mahajan, Mumbai.
                    </p>
                </div>

                <div class="p-6 sm:p-8">
                    <div v-if="loading" class="text-center py-10">
                        <p class="text-gray-500">Loading past vice presidents information...</p>
                        <!-- Optional: Add a spinner/loader animation here -->
                    </div>
                    <div v-else-if="pastVicePresidents && pastVicePresidents.length > 0">
                      <div class="trustees-grid">
                            <div v-for="(member, index) in pastVicePresidents" :key="index" class="trustee-card">
                                <img :src="member.photo" class="trustee-photo" alt="Trustee Photo" />
                                <div class="trustee-info">
                                    <div class="trustee-name">{{ member.memberName }}</div>
                                    <!-- Add more fields as needed -->
                                </div>
                                <div class="trustee-card-overlay"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center py-10">
                        <p class="text-gray-500">Past vice president information is currently unavailable.</p>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'
import axiosInstance from '@/utils/axiosInstance';
import placeholder from '@/assets/image-placeholder.png';

export default {
  name: 'PastVicePresidentsPage',
  components: {
    Layout
  },
  data() {
    return {
      pastVicePresidents: [],
      loading: true,
      placeholderImage: placeholder,
    };
  },
  async created() {
    try {
      const response = await axiosInstance.get('About-page?populate[pastVicePresidents][populate]=memberProfilePhoto'); 
      const responseAttributes = response.data.data.attributes;
      
      this.pastVicePresidents = (responseAttributes.pastVicePresidents || []).map(member => ({
        id: member.id, // Assuming an ID exists
        memberName: member.memberName,
        memberTenure: member.memberTenure || '', 
        photo: member.memberProfilePhoto?.data?.attributes?.url || this.placeholderImage,
      }));
    } catch (error) {
      console.error('Failed to fetch Past Vice Presidents:', error);
      this.pastVicePresidents = []; // Set to empty on error
    } finally {
      this.loading = false;
    }
  },
}
</script>
<style scoped>
.trustees-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 2rem;
  padding: 1.5rem 0;
}
.trustee-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px #0001;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.2rem 1.2rem 1.2rem 1.2rem;
  position: relative;
  overflow: hidden;
  min-height: 320px;
  transition: box-shadow 0.25s, transform 0.25s;
  cursor: pointer;
}
.trustee-card-gradient {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #f5eee6 0%, #e3d5ca 100%);
  opacity: 0.35;
  z-index: 0;
  pointer-events: none;
  border-radius: 20px;
  transition: background 0.25s;
}
.trustee-card:hover {
  box-shadow: 0 8px 32px #b0896833;
  transform: translateY(-6px) scale(1.03);
}
.trustee-photo-wrapper {
  position: relative;
  margin-bottom: 1.1rem;
  z-index: 1;
}
.trustee-photo {
  width: 200px;
  height: 200px;
  object-fit: cover;
  object-position: top;
  border-radius: 50%;
  background: #ede0d4;
  border: 4px solid #fff;
  box-shadow: 0 2px 12px #b0896822;
  z-index: 1;
  transition: box-shadow 0.25s;
}
.trustee-card:hover .trustee-photo {
  box-shadow: 0 4px 24px #b0896844;
}
.trustee-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #b08968;
  color: #fff;
  font-size: 1.2rem;
  border-radius: 50%;
  padding: 0.3em 0.45em;
  box-shadow: 0 2px 8px #b0896844;
  z-index: 2;
  font-weight: bold;
  border: 2px solid #fff;
}
.trustee-info {
  text-align: center;
  z-index: 1;
  position: relative;
}
.trustee-name {
  font-weight: 700;
  font-size: 1.18rem;
  margin-bottom: 0.18rem;
  color: #00395a;
  letter-spacing: 0.01em;
  margin-top: 10%;
}
.trustee-role {
  font-size: 1.02rem;
  color: #b08968;
  font-weight: 500;
  margin-bottom: 0.5rem;
  letter-spacing: 0.01em;
}
.trustee-contact {
  font-size: 0.98rem;
  color: #00395a;
  margin-bottom: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
}
.trustee-contact a {
  color: #b08968;
  text-decoration: none;
  transition: color 0.2s;
}
.trustee-contact a:hover {
  color: #00395a;
  text-decoration: underline;
}
@media (max-width: 600px) {
  .trustees-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
  .trustee-card {
    min-height: 220px;
    padding: 1.2rem 0.5rem;
  }
}
</style>
